import { request } from "../../../../../apis";
import localStorageKey from "../../../../../enumerations/localStorageKey";

const defaultCurrency = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);

export const apiPutDepositRead = (params) =>
  request("put", `/${defaultCurrency}/payment/deposit/read`, params, true, false);

export const apiGetDepositCount = () =>
  request("get", `/${defaultCurrency}/payment/deposit/count`, null, true, false);
